<template>
  <div>
    <header class="form-header">
      <div class="heading-2 neutral-2-color">
        <slot name="title">Log in with your networks</slot>
      </div>
    </header>

    <div class="social-buttons-container">
      <slot name="social-buttons"></slot>
    </div>

    <div class="field">
      <label>
        <div class="field-label">Email</div>
        <cp-text-input type="email" class="form-input" name="existing_email" v-model="email" block placeholder="Your Email Address"></cp-text-input>
      </label>
    </div>
    <div class="field">
      <label>
        <cp-grid class="field-label">
          <cp-grid-item span="auto">Password</cp-grid-item>
        </cp-grid>
        <cp-text-input type="password" class="form-input" name="existing_password" v-model="password" block placeholder="Your Password"></cp-text-input>
      </label>
    </div>
    <div class="forgotContainer">
      <a class="caption1 primary-color" href="/user/password/remind">Forgot your password?</a>
    </div>
  </div>
</template>

<script>
import CpButton from '../button';
import CpGrid from '../grid';
import CpGridItem from '../grid-item';
import CpTextInput from '../inputs/text';

export default {
  components: {
    CpButton,
    CpGrid,
    CpGridItem,
    CpTextInput,
  },

  data() {
    return {
      email: '',
      password: '',
    };
  },
};
</script>

<style scoped>
.social-buttons-container {
  padding-top: 20px;
}

.forgotContainer {
  display: flex;
  justify-content: flex-end;
}
</style>
